import { MotifIcon } from '@ey-xd/motif-react'
import WorkspaceStatus from '../atoms/WorkspaceStatus'
import iconSvg from "../../assets/icons/icon.svg.json";
import AppTable from '../atoms/AppTable';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { datePipeForTable } from '../../helpers/util';

const ApprovalsListTable = (props: any) => {
    const { tableData } = props;
    // const tableData = mydata[0]
    const navigate = useNavigate();
    const { access } = useSelector((state: any) => state.user);

    const columns = [
        { header: 'S.No.', accessor: 'serial', 
            render: (data) => (
                <p>
                    {tableData.findIndex(item => item.Id === data.Id) + 1}
                </p>
            )
        },
        { header: 'Question', accessor: 'Question' },
        { header: 'Customized query added by', accessor: 'CreatedBy'},
        //     render: (data) => (
        //         <p>
        //             User Avatar and Name
        //         </p>
        //     )
        //  },
        { header: 'Edit Added on', accessor: 'serial',
            render: (data) => (
                <p>
                {data.CreatedDate}
                </p>
            )
        },
        //  { header: 'Added on', accessor: 'CreatedDate',
        //     render: (data) => (
        //         <p>
        //             {datePipeForTable(data.CreatedDate)}
        //         </p>
        //     )
        //   },
         { header: 'Status', accessor: 'Status',
             render: (data) => (
                 <WorkspaceStatus status={data?.Status} />
             )
          },
        {
          header: 'Action',
          accessor: 'action',
          render: (data) => (
            <MotifIcon title={access.write === false ? "Write access denied" : ""} onClick={() => {
                if(access.write === false) {
                    alert("Write access denied")
                    return;
                }
                navigate(`/admin/approvals/${data.EngagementId}`, {state: tableData.findIndex(item => item.Id === data.Id)})
            }} src={iconSvg["edit-icon"]} className="!w-6 cursor-pointer" />
          ),
        },
      ];

    return (
        <AppTable columns={columns} tableData={tableData} />
    )
}

export default ApprovalsListTable